/**
 * Часы браузера.
 *
 * Монотонные и календарные часы разделены: длительность сессии не должна
 * зависеть от перевода системного времени или синхронизации NTP
 * (решение AD-013).
 */

import type { Clock } from '@type2x/feature-personal-workspace';

/** Часы на основе performance.now и Date. */
export function createBrowserClock(): Clock {
  return {
    monotonicMs: () => globalThis.performance.now(),
    epochMs: () => Date.now(),
    isoNow: () => new Date().toISOString(),
  };
}

/** Управляемые часы для тестов и воспроизведения сценариев. */
export function createFixedClock(startEpochMs: number): Clock & { advance(ms: number): void } {
  let monotonic = 0;
  let epoch = startEpochMs;

  return {
    monotonicMs: () => monotonic,
    epochMs: () => epoch,
    isoNow: () => new Date(epoch).toISOString(),
    advance(ms: number) {
      monotonic += ms;
      epoch += ms;
    },
  };
}
